export function parseJsonPayload(raw) {
  if (raw == null || raw === '') return null;
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch (error) {
    console.error('Invalid WebSocket payload:', error);
    return null;
  }
}
